import React from 'react';
import './App.css';
import CompressorComp 
	from "./Components/Compressor";
import 'bootstrap/dist/css/bootstrap.css';
function App() {
	return (
		<CompressorComp />
	);
}
export default App;
